"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TABLE_HEAD_CELLS = void 0;
exports.TABLE_HEAD_CELLS = [{ name: "Port Name" }, { name: "" }];
